module.exports = __webpack_public_path__ + "static/media/filter.2b2234ad.svg";